// extracted by mini-css-extract-plugin
export default {"root":"EnvironmentPanel_root","saveButton":"EnvironmentPanel_saveButton","disabled":"EnvironmentPanel_disabled"};